import useAccountFeatureFlag from 'util/hooks/useAccountFeatureFlag'

/**
 * Whether this account uses the Helply widget embedded in the HTML template.
 * The helply-agent-ready preference controls the help icon and unread subscription.
 */
const useHelplyWidgetEnabled = () => {
  const widget = useAccountFeatureFlag('helply-agent-ready')
  return { widget }
}

export default useHelplyWidgetEnabled
